import React, { Component } from 'react'
import AutoCompleteUsers from '../../../../util/auto_complete/Users'
import Toggle from '../Form/toggle'

export default class RoutingTypeChooser extends Component {

  state = {
    user_id: this.props.user_id,
    mode: this.props.mode,
    notify: this.props.notify
  }

  getState() {
    return this.state
  }

  getManualRecipient() {
    const { mode, notify, user_id } = this.state
    if (mode === 'Manual') {
      return (
        <td>
          <div style={{display: 'flex'}}>
            <AutoCompleteUsers selected={user_id} onSelect={user => this.setState({ user_id: user && user.id })} />
            <Toggle on={notify} onChange={notify => this.setState({ notify })}>Send to Agent</Toggle>
          </div>
        </td>
      )
    } else {
      return (
        <td><em>Random</em></td>
      )
    }
  }

  handleChange = event => {
    const { premium } = this.props
    const mode = event.target.value
    if (mode === 'Round Robin' && !premium) {
      event.preventDefault()
      alert('You must upgrade to Premium Plan to use Round Robin.')
    } else {
      this.setState({ mode: event.target.value })
    }
  }

  render() {
    const { title } = this.props
    const { mode } = this.state
    return (
      <tr>
        <td>{title}</td>
        <td>
          <select value={mode} onChange={this.handleChange}>
            <option value="Round Robin">Round Robin</option>
            <option value="Manual">Manual</option>
          </select>
        </td>
        {this.getManualRecipient()}
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/LeadRouting/RoutingTypeChooser.js